import { ApiEndpointsForResource } from "/shortcodes";
import * as React from 'react';
export default {
  ApiEndpointsForResource,
  React
};